import JobsApp from './JobsApp';

export default JobsApp;
